import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmBarService {
  confirmBar: Subject<{
    label?: string, label2?: string, status: boolean, cancelLabel?: string, proceedLabel?: string, proceedLabel2?:string
  }> = new Subject();

  confirmBarAction: Subject<'back' | 'one' | 'two'> = new Subject();

  constructor() { }
}
